/**
 * 散点图
 * 
 * 晚睡早起
 */
export default function getEchartsOptionScatterA1(
	xAxis_data,
	yAxis_data,
	series_data0,
	series_data1,
	series_data2,
	series_data3,
	scatter_interval1,
	scatter_interval2,
	scatter_interval3,
	scatter_interval4
) {
	let option = {
		tooltip: {
		  type: 'none',
		  axisPointer: { // 十字
			type: 'cross',
			snap: false,
			animation: true,
			label: {
			  color: '#FFFFFF',
			  backgroundColor: '#5F64E7',
			  opacity: 1
			},
			crossStyle: {
			  color: '#BCB6E8',
			  width: 1
			}
		  },
		  backgroundColor: "#FFFFFF",
		  borderColor: "#ABD7FF",
		  borderWidth: 1,
		  borderRadius: 5,
		  textStyle: {
			color: "#8394B9",
			fontSize: 14
		  },
		  confine: true,
		  formatter: function (val) {
			if (val && val.seriesName) {
				return val.seriesName + '<br/>' + val.marker + val.value[1] + '为' + val.value[0].toString();
			}
		  }
		},
		xAxis: [
		  {
			position: 'top',
			axisLabel: {
			  show: false
			},
			axisLine: {
			  show: false
			},
			axisTick: {
			  show: false
			},
			data: xAxis_data,
		  }
		],
		yAxis: [
		  {
			axisLine: {
			  show: false
			},
			axisLabel: {
			  color: '#A5A9BC',
			  fontSize: 10
			},
			axisTick: {
			  show: false
			},
			inverse: true, // 反转
			data: yAxis_data,
			splitArea: {
			  show: true,
			  interval: 'auto',
			  areaStyle: {
			  }
			}
		  }
		],
		grid: {
		  x: 12,
		  y: -1,
		  x2: 12,
		  y2: 1,
		  containLabel: true
		},
		series: [
		  {
			name: '上床时间',
			data: series_data0,
			type: 'scatter',
			symbol: 'circle',
			symbolSize: [6 , 6],
			itemStyle: {
			  normal: {
				color: '#FF7186'
			  },
			},
			showBackground: true,
			backgroundStyle: {
			  color: 'red'
			},
			markArea: {
			  itemStyle: {
				color: '#FF718630'
			  },
			  data: scatter_interval1
			}
		  },
		  {
			name: '入睡时间',
			data: series_data1,
			type: 'scatter',
			symbol: 'circle',
			symbolSize: [6 , 6],
			itemStyle: {
			  normal: {
				color: '#FFB971'
			  },
			},
			showBackground: true,
			backgroundStyle: {
			  color: 'red'
			},
			markArea: {
			  itemStyle: {
				color: '#FAAB6230'
			  },
			  data: scatter_interval2
			}
		  },
		  {
			name: '醒来时间',
			data: series_data2,
			type: 'scatter',
			symbol: 'circle',
			symbolSize: [6 , 6],
			itemStyle: {
			  normal: {
				color: '#44D7B6'
			  },
			},
			showBackground: true,
			backgroundStyle: {
			  color: '#FF7186'
			},
			markArea: {
			  itemStyle: {
				color: '#44D7B630'
			  },
			  data: scatter_interval3
			}
		  },
		  {
			name: '起床时间',
			data: series_data3,
			type: 'scatter',
			symbol: 'circle',
			symbolSize: [6 , 6],
			itemStyle: {
			  normal: {
				color: '#1890FF'
			  },
			},
			showBackground: true,
			backgroundStyle: {
			  color: 'red'
			},
			markArea: {
			  itemStyle: {
				color: '#1890FF30'
			  },
			  data: scatter_interval4
			}
		  }
		],
		// dataZoom: [
		//   {
		//     type: 'inside',
		//     orient: 'vertical',
		//     start: 100,
		//     maxValueSpan: 6,
		//     minValueSpan: 6,
		//     zoomLock: true,
		//   }
		// ]
	  };
	return option;
}